// Author Lin
// Date 2021-11-26 11:19:21

class MintalMesPrdSmeltingCirculatingWater {
constructor({
        id = null,
        measureTime = '',
        locationId = '',
        locationName = '',
        furnaceId = '',
        furnaceName = '',
        stabilizingPipePressure = '',
        stabilizingPipeLevel = '',
        closedLoopPressure = '',
        closedLoopFlow = '',
        separatorFlowOne = '',
        separatorFlowTwo = '',
        separatorFlowThree = '',
        separatorFlowFour = '',
        separatorPressureFour = '',
        separatorFlowFive = '',
        separatorFlowSix = '',
        remark = ''}
= {}) {
    this.id = id;
    this.measureTime = measureTime;
    this.locationId = locationId;
    this.locationName = locationName;
    this.furnaceId = furnaceId;
    this.furnaceName = furnaceName;
    this.stabilizingPipePressure = stabilizingPipePressure;
    this.stabilizingPipeLevel = stabilizingPipeLevel;
    this.closedLoopPressure = closedLoopPressure;
    this.closedLoopFlow = closedLoopFlow;
    this.separatorFlowOne = separatorFlowOne;
    this.separatorFlowTwo = separatorFlowTwo;
    this.separatorFlowThree = separatorFlowThree;
    this.separatorFlowFour = separatorFlowFour;
    this.separatorPressureFour = separatorPressureFour;
    this.separatorFlowFive = separatorFlowFive;
    this.separatorFlowSix = separatorFlowSix;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdSmeltingCirculatingWater();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'measureTime',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.measureTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'furnaceName',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.furnaceName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'stabilizingPipePressure',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.stabilizingPipePressure',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'stabilizingPipeLevel',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.stabilizingPipeLevel',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'closedLoopPressure',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.closedLoopPressure',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'closedLoopFlow',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.closedLoopFlow',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'separatorFlowOne',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.separatorFlowOne',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'separatorFlowTwo',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.separatorFlowTwo',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'separatorFlowThree',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.separatorFlowThree',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'separatorFlowFour',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.separatorFlowFour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'separatorPressureFour',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.separatorPressureFour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'separatorFlowFive',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.separatorFlowFive',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'separatorFlowSix',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.separatorFlowSix',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    measureTimeRteFilter : '',
    measureTimeLteFilter : '',
    locationIdFilter : '',
    locationNameFilter : '',
    furnaceIdFilter : '',
    furnaceNameFilter : '',
    stabilizingPipePressureFilter : '',
    stabilizingPipeLevelFilter : '',
    closedLoopPressureFilter : '',
    closedLoopFlowFilter : '',
    separatorFlowOneFilter : '',
    separatorFlowTwoFilter : '',
    separatorFlowThreeFilter : '',
    separatorFlowFourFilter : '',
    separatorPressureFourFilter : '',
    separatorFlowFiveFilter : '',
    separatorFlowSixFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'measureTimeRteFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.filter.measureTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'measureTimeLteFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.filter.measureTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'locationNameFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.filter.locationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                }
        },
        {
        key: 'furnaceNameFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.filter.furnaceName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstFurnace'
            ,correspondingField: 'furnaceName'
            ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'measureTime',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.measureTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.locationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                }
        },
        {
        key: 'furnaceName',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.furnaceName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'mintalMesMstFurnace'
            ,correspondingField: 'furnaceName'
            ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                }
        },
        {
        key: 'stabilizingPipePressure',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.stabilizingPipePressure',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'stabilizingPipeLevel',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.stabilizingPipeLevel',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'closedLoopPressure',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.closedLoopPressure',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'closedLoopFlow',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.closedLoopFlow',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'separatorFlowOne',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.separatorFlowOne',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'separatorFlowTwo',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.separatorFlowTwo',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'separatorFlowThree',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.separatorFlowThree',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'separatorFlowFour',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.separatorFlowFour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'separatorPressureFour',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.separatorPressureFour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'separatorFlowFive',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.separatorFlowFive',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'separatorFlowSix',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.separatorFlowSix',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdSmeltingCirculatingWater.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdSmeltingCirculatingWater, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
